import { render, staticRenderFns } from "./no_billing_forbidden_empty_state.vue?vue&type=template&id=5aac12d9"
import script from "./no_billing_forbidden_empty_state.vue?vue&type=script&lang=js"
export * from "./no_billing_forbidden_empty_state.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports